var getBaseURL = function getBaseURL() {
  return window.location.origin;
};

/**
 * Generates URL functions for the Compass tab, with appropriate absolute URLs.
 * @param {string} searchUrlOverride - Override for the base URL used for search links
 * @returns functions for generating Compass URLs
 */
export var compassURLGenerators = function compassURLGenerators(searchUrlOverride) {
  var advancedSearchLinkGenerator = function advancedSearchLinkGenerator(query) {
    return "".concat(searchUrlOverride || getBaseURL(), "/compass/components?query=").concat(encodeURIComponent(query));
  };
  var teamUrlGenerator = function teamUrlGenerator(teamId) {
    return "".concat(getBaseURL(), "/compass/people/team/").concat(teamId);
  };
  var userUrlGenerator = function userUrlGenerator(userId) {
    return "".concat(getBaseURL(), "/people/").concat(userId);
  };
  return {
    advancedSearchLinkGenerator: advancedSearchLinkGenerator,
    teamUrlGenerator: teamUrlGenerator,
    userUrlGenerator: userUrlGenerator
  };
};